import React from 'react';
import AndroidSvgSrc, { ReactComponent as Android } from '@svg/android.svg';
import IosSvgSrc, { ReactComponent as Ios } from '@svg/ios.svg';
import JavascriptSvgSrc, { ReactComponent as Javascript } from '@svg/javascript.svg';
import UnitySvgSrc, { ReactComponent as Unity } from '@svg/unity.svg';
import RubySvgSrc, { ReactComponent as Ruby } from '@svg/ruby.svg';
import RustSvgSrc, { ReactComponent as Rust } from '@svg/rust.svg';
import NodeSvgSrc, { ReactComponent as Node } from '@svg/node.svg';
import GoSvgSrc, { ReactComponent as Go } from '@svg/go.svg';
import ReactNativeSvgSrc, { ReactComponent as ReactNative } from '@svg/reactnative.svg';
import PythonSvgSrc, { ReactComponent as Python } from '@svg/python.svg';
import FlutterSvgSrc, { ReactComponent as Flutter } from '@svg/flutter.svg';
import CordovaSvgSrc, { ReactComponent as Cordova } from '@svg/cordova.svg';
import HTTPSvgSrc, { ReactComponent as HTTP } from '@svg/http.svg';
import AMPSvgSrc, { ReactComponent as AMP } from '@svg/amp.svg';
import CustomerIOSvgSrc, { ReactComponent as CustomerIO } from '@svg/customerio.svg';
import LookerSvgSrc, { ReactComponent as Looker } from '@svg/looker.svg';
import JavaSvgSrc, { ReactComponent as Java } from '@svg/java.svg';
import Auth0SvgSrc, { ReactComponent as Auth0 } from '@svg/auth0.svg';
import SegmentSvgSrc, { ReactComponent as Segment } from '@svg/segment.svg';
import GoogleSheetSvgSrc, { ReactComponent as GoogleSheet } from '@svg/googlesheets.svg';
import SalesforceSvgSrc, { ReactComponent as Salesforce } from '@svg/salesforce.svg';
import DotNetSvgSrc, { ReactComponent as DotNet } from '@svg/dotnet.svg';
import ZendeskSvgSrc, { ReactComponent as Zendesk } from '@svg/zendesk.svg';
import FacebookSvgSrc, { ReactComponent as Facebook } from '@svg/facebook_ads.svg';
import GoogleSearchConsoleSvgSrc, {
  ReactComponent as GoogleSearchConsole,
} from '@svg/google_search_console.svg';
import GoogleAdsSvgSrc, { ReactComponent as GoogleAds } from '@svg/googleads.svg';
import GoogleAnalyticsSvgSrc, { ReactComponent as GoogleAnalytics } from '@svg/ga.svg';
import PHPSvgSrc, { ReactComponent as PHP } from '@svg/php.svg';
import IntercomSvgSrc, { ReactComponent as Intercom } from '@svg/intercom.svg';
import BigQuerySvgSrc, { ReactComponent as BigQuery } from '@svg/bigquery.svg';
import RedshiftSvgSrc, { ReactComponent as Redshift } from '@svg/redshift.svg';
import MsSqlSvgSrc, { ReactComponent as MSSQL } from '@svg/mssql.svg';
import AzureSynapseSvgSrc, { ReactComponent as AZURE_SYNAPSE } from '@svg/azure_synapse.svg';
import SnowflakeSvgSrc, { ReactComponent as Snowflake } from '@svg/snowflake.svg';
import ClickhouseSvgSrc, { ReactComponent as Clickhouse } from '@svg/clickhouse.svg';
import PostgresSvgSrc, { ReactComponent as Postgres } from '@svg/postgres.svg';
import LinkedInSvgSrc, { ReactComponent as LinkedIn } from '@svg/linkedin_ads.svg';
import AppsflyerSvgSrc, { ReactComponent as Appsflyer } from '@svg/af.svg';
import PipedrivevgSrc, { ReactComponent as Pipedrive } from '@svg/pipedrive.svg';
import MarketoSvgSrc, { ReactComponent as Marketo } from '@svg/marketo.svg';
import S3SvgSrc, { ReactComponent as S3 } from '@svg/s3.svg';
import XeroSvgSrc, { ReactComponent as Xero } from '@svg/xero.svg';
import BingAdsSvgSrc, { ReactComponent as BingAds } from '@svg/bing_ads.svg';
import NetsuiteSvgSrc, { ReactComponent as Netsuite } from '@svg/netsuite.svg';
import MixpanelSvgSrc, { ReactComponent as Mixpanel } from '@svg/mp.svg';
import ZendeskChatSvgSrc, { ReactComponent as ZendeskChat } from '@svg/zendesk_chat.svg';
import MailchimpSvgSrc, { ReactComponent as Mailchimp } from '@svg/mailchimp.svg';
import PosthogSvgSrc, { ReactComponent as Posthog } from '@svg/posthog.svg';
import { ReactComponent as STRIPE } from '@svg/stripe.svg';
import { ReactComponent as Pardot } from '@svg/pardot.svg';
import { ReactComponent as APPCENTER } from '@svg/appcenter.svg';
import { ReactComponent as Freshdesk } from '@svg/freshdesk.svg';
import { ReactComponent as Hubspot } from '@svg/hubspot.svg';
import { ReactComponent as Quickbooks } from '@svg/quickbooks.svg';
import { ReactComponent as Extole } from '@svg/extole.svg';
import BrazeSrc, { ReactComponent as BRAZE } from '@svg/braze.svg';
import { ReactComponent as ACTIVE_CAMPAIGN } from '@svg/active_campaign.svg';
import { ReactComponent as SENDGRID } from '@svg/sendgrid.svg';
import { ReactComponent as WEBHOOK } from '@svg/webhook_source.svg';
import ChargebeeSvgSrc, { ReactComponent as CHARGEBEE } from '@svg/chargebee.svg';
import RecurlySvgSrc, { ReactComponent as RECURLY } from '@svg/recurly.svg';
import IterableSvgSrc, { ReactComponent as ITERABLE } from '@svg/Iterable.svg';
import KlaviyoSvgSrc, { ReactComponent as KLAVIYO } from '@svg/klaviyo.svg';
import { ReactComponent as SHOPIFY } from '@svg/shopify.svg';
import { ReactComponent as MYSQL } from '@svg/mysql.svg';
import { ReactComponent as DATABRICKS } from '@svg/databricks.svg';

interface SourceIconProps extends React.SVGAttributes<unknown> {
  source: string;
  size?: number | 'string';
  imgtag?: boolean;
}
const SourceIcon = ({ size, source, imgtag, ...restProps }: SourceIconProps) => {
  let Icon: React.FC | 'div';
  let iconPath = '';
  switch (source.toLowerCase()) {
    case 'android':
      Icon = Android;
      iconPath = AndroidSvgSrc;
      break;
    case 'ios':
      Icon = Ios;
      iconPath = IosSvgSrc;
      break;
    case 'javascript':
      Icon = Javascript;
      iconPath = JavascriptSvgSrc;
      break;
    case 'unity':
      Icon = Unity;
      iconPath = UnitySvgSrc;
      break;
    case 'ruby':
      Icon = Ruby;
      iconPath = RubySvgSrc;
      break;
    case 'rust':
      Icon = Rust;
      iconPath = RustSvgSrc;
      break;
    case 'node':
      Icon = Node;
      iconPath = NodeSvgSrc;
      break;
    case 'go':
      Icon = Go;
      iconPath = GoSvgSrc;
      break;
    case 'reactnative':
      Icon = ReactNative;
      iconPath = ReactNativeSvgSrc;
      break;
    case 'python':
      Icon = Python;
      iconPath = PythonSvgSrc;
      break;
    case 'http':
      Icon = HTTP;
      iconPath = HTTPSvgSrc;
      break;
    case 'amp':
      Icon = AMP;
      iconPath = AMPSvgSrc;
      break;
    case 'customerio':
      Icon = CustomerIO;
      iconPath = CustomerIOSvgSrc;
      break;
    case 'looker':
      Icon = Looker;
      iconPath = LookerSvgSrc;
      break;
    case 'java':
      Icon = Java;
      iconPath = JavaSvgSrc;
      break;
    case 'auth0':
      Icon = Auth0;
      iconPath = Auth0SvgSrc;
      break;
    case 'appcenter':
      Icon = APPCENTER;
      break;
    case 'segment':
      Icon = Segment;
      iconPath = SegmentSvgSrc;
      break;
    case 'extole':
      Icon = Extole;
      break;
    case 'singer-google-sheets':
    case 'google_sheets':
      Icon = GoogleSheet;
      iconPath = GoogleSheetSvgSrc;
      break;
    case 'singer-salesforce':
    case 'salesforce':
      Icon = Salesforce;
      iconPath = SalesforceSvgSrc;
      break;
    case 'dotnet':
      Icon = DotNet;
      iconPath = DotNetSvgSrc;
      break;
    case 'singer-zendesk':
    case 'zendesk':
      Icon = Zendesk;
      iconPath = ZendeskSvgSrc;
      break;
    case 'singer-zendesk-chat':
    case 'zendesk_chat':
      Icon = ZendeskChat;
      iconPath = ZendeskChatSvgSrc;
      break;
    case 'singer-facebook-marketing':
    case 'facebook_ads':
      Icon = Facebook;
      iconPath = FacebookSvgSrc;
      break;
    case 'singer-google-search-console':
    case 'google_search_console':
      Icon = GoogleSearchConsole;
      iconPath = GoogleSearchConsoleSvgSrc;
      break;
    case 'google_adwords':
    case 'singer-google_adwords':
      Icon = GoogleAds;
      iconPath = GoogleAdsSvgSrc;
      break;
    case 'php':
      Icon = PHP;
      iconPath = PHPSvgSrc;
      break;
    case 'intercom':
    case 'singer-intercom':
      Icon = Intercom;
      iconPath = IntercomSvgSrc;
      break;
    case 'bigquery':
      Icon = BigQuery;
      iconPath = BigQuerySvgSrc;
      break;
    case 'postgres':
      Icon = Postgres;
      iconPath = PostgresSvgSrc;
      break;
    case 'redshift':
      Icon = Redshift;
      iconPath = RedshiftSvgSrc;
      break;
    case 'mssql':
      Icon = MSSQL;
      iconPath = MsSqlSvgSrc;
      break;
    case 'azure_synapse':
      Icon = AZURE_SYNAPSE;
      iconPath = AzureSynapseSvgSrc;
      break;
    case 'clickhouse':
      Icon = Clickhouse;
      iconPath = ClickhouseSvgSrc;
      break;
    case 'snowflake':
      Icon = Snowflake;
      iconPath = SnowflakeSvgSrc;
      break;
    case 'linkedin_ads':
      Icon = LinkedIn;
      iconPath = LinkedInSvgSrc;
      break;
    case 'singer-google-analytics':
    case 'google_analytics':
      Icon = GoogleAnalytics;
      iconPath = GoogleAnalyticsSvgSrc;
      break;
    case 'appsflyer':
      Icon = Appsflyer;
      iconPath = AppsflyerSvgSrc;
      break;
    case 'singer-pipedrive':
    case 'pipedrive':
      Icon = Pipedrive;
      iconPath = PipedrivevgSrc;
      break;
    case 's3':
      Icon = S3;
      iconPath = S3SvgSrc;
      break;
    case 'marketo':
      Icon = Marketo;
      iconPath = MarketoSvgSrc;
      break;
    case 'xero':
      Icon = Xero;
      iconPath = XeroSvgSrc;
      break;
    case 'singer-bing-ads':
    case 'bing_ads':
      Icon = BingAds;
      iconPath = BingAdsSvgSrc;
      break;
    case 'netsuite':
      Icon = Netsuite;
      iconPath = NetsuiteSvgSrc;
      break;
    case 'singer-mailchimp':
    case 'mailchimp':
      Icon = Mailchimp;
      iconPath = MailchimpSvgSrc;
      break;
    case 'singer-mixpanel':
    case 'mixpanel':
      Icon = Mixpanel;
      iconPath = MixpanelSvgSrc;
      break;
    case 'singer-pardot':
    case 'pardot':
      Icon = Pardot;
      break;
    case 'flutter':
      Icon = Flutter;
      iconPath = FlutterSvgSrc;
      break;
    case 'cordova':
      Icon = Cordova;
      iconPath = CordovaSvgSrc;
      break;
    case 'posthog':
      Icon = Posthog;
      iconPath = PosthogSvgSrc;
      break;
    case 'singer-stripe':
    case 'stripe':
      Icon = STRIPE;
      break;
    case 'singer-freshdesk':
    case 'freshdesk':
      Icon = Freshdesk;
      break;
    case 'braze':
      Icon = BRAZE;
      iconPath = BrazeSrc;
      break;
    case 'hubspot':
    case 'singer-hubspot':
      Icon = Hubspot;
      break;
    case 'singer-quickbooks':
    case 'quickbooks':
      Icon = Quickbooks;
      break;
    case 'active_campaign':
      Icon = ACTIVE_CAMPAIGN;
      break;
    case 'singer-sendgrid':
    case 'sendgrid':
      Icon = SENDGRID;
      break;
    case 'singer-chargebee':
      Icon = CHARGEBEE;
      iconPath = ChargebeeSvgSrc;
      break;
    case 'singer-recurly':
      Icon = RECURLY;
      iconPath = RecurlySvgSrc;
      break;
    case 'webhook':
      Icon = WEBHOOK;
      break;
    case 'iterable':
    case 'singer-iterable':
      Icon = ITERABLE;
      iconPath = IterableSvgSrc;
      break;
    case 'singer-klaviyo':
      Icon = KLAVIYO;
      iconPath = KlaviyoSvgSrc;
      break;
    case 'shopify':
      Icon = SHOPIFY;
      break;
    case 'mysql':
      Icon = MYSQL;
      break;
    case 'databricks':
      Icon = DATABRICKS;
      break;
    default:
      Icon = 'div';
      break;
  }

  const sizeProps =
    (size && {
      width: size,
      height: size,
    }) ||
    {};
  let iconComponent = <Icon {...sizeProps} {...restProps} />;

  if (imgtag) {
    iconComponent = (
      <img alt="source" src={iconPath} style={{ height: size || '16px', width: size || '16px' }} />
    );
  }
  return iconComponent;
};

export default SourceIcon;
